import { IconClipboardPlus, IconLogout, IconSettings } from '@tabler/icons-react'

import { basePaths } from '~/app/routes'
import { AstraParagraph, UserMenu as UserMenuComponent, UserMenuDivider, UserMenuItem } from '~/astra'
import env from '~/env'
import { useFlag } from '~/hooks/useFlag'
import { useStore } from '~/store/store'

import { getPKCELogoutUrl, pkceClearLocalStorage } from '../PKCEAuthenticationFlow'

export const UserMenu = () => {
    const showAdminPageInNavMenu = useFlag('navigation_menu__admin_page')
    const isHospitalConfigurationPageEnabled = useFlag('hospital_configuration_page__enabled')

    const idTokenPKCE = useStore(state => state.user.idTokenPKCE)
    const dipsApiAccessTokenIsFromPKCE = useStore(state => state.user.dipsApiAccessTokenIsFromPKCE)
    const { display_name, username } = useStore(state => state.user)
    const hospitalConfigurationView = useStore(state => state.app.activeViews.HOSPITAL_CONFIGURATION)

    const logoutUrl = dipsApiAccessTokenIsFromPKCE ? getPKCELogoutUrl(idTokenPKCE) : env.VITE_API_BASE_URL + '/oauth/logout'

    const handleLogout = () => {
        if (dipsApiAccessTokenIsFromPKCE) {
            pkceClearLocalStorage()
        }

        // For routes outside the React router, we always use a full page reload navigation
        window.location.assign(logoutUrl)
    }

    return (
        <UserMenuComponent username={display_name ?? username ?? ''}>
            {(isHospitalConfigurationPageEnabled || showAdminPageInNavMenu) && (
                <>
                    <UserMenuDivider />

                    {isHospitalConfigurationPageEnabled && (
                        <UserMenuItem to={hospitalConfigurationView}>
                            <IconClipboardPlus size={16} />
                            <AstraParagraph className="whitespace-nowrap text-start" variant="body-small">
                                Sykehusoppsett
                            </AstraParagraph>
                        </UserMenuItem>
                    )}

                    {showAdminPageInNavMenu && (
                        <UserMenuItem to={basePaths.ADMIN_PANEL}>
                            <IconSettings size={16} />
                            <AstraParagraph className="whitespace-nowrap text-start" variant="body-small">
                                Admin
                            </AstraParagraph>
                        </UserMenuItem>
                    )}
                </>
            )}

            <UserMenuDivider />

            <UserMenuItem data-test="logout-button" onClick={handleLogout}>
                <IconLogout size={16} />
                <AstraParagraph className="whitespace-nowrap text-start" variant="body-small">
                    Logg ut
                </AstraParagraph>
            </UserMenuItem>
        </UserMenuComponent>
    )
}
